"use strict";
import React from "react";
import CarrierService from "../services/carrier_service";
import Account from "../api/account";
import { Tooltip, TooltipDirection, TooltipLocation } from "./ui/v3/tooltip";
import Auth from "../util/auth";
function carrierName(props, state) {
  let name = state.carrier.name;
  if (shouldIncludeExternalVendorId(props, state)) {
    name += " - ";
    name += state.carrier.external_vendor_id;
  }
  if (props.displayNoBuy && state.carrier.data && state.carrier.data["no_buy"]) {
    return /* @__PURE__ */ React.createElement(
      "span",
      {
        "data-tooltip": true,
        "aria-haspopup": "true",
        title: "Client marked Do Not Allow Purchases"
      },
      /* @__PURE__ */ React.createElement("i", { className: "fi-alert alert" }),
      " ",
      name,
      " "
    );
  }
  return name;
}
function shouldIncludeExternalVendorId(props, state) {
  return state.carrier.external_vendor_id && Auth._currentUser.account.factor_account && props.includeExternalVendorId;
}
function renderV3Reskin(props, state) {
  if (props.multiple) {
    const carrierNames = (props.carrierInvoices || []).map((carrierInvoice) => {
      const carrier = CarrierService.getCarrierOrUnknown(
        carrierInvoice.carrier_id
      );
      return carrier.name;
    });
    if (carrierNames.length < 3) {
      const content = carrierNames.map((carrierName2, i) => /* @__PURE__ */ React.createElement("span", { key: carrierName2 }, carrierName2, i == 0 ? ", " : ""));
      return /* @__PURE__ */ React.createElement("span", null, content, " ", props.trailingChip);
    } else {
      const tooltipContent = carrierNames.map((carrierName2) => {
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            style: { whiteSpace: "nowrap" },
            key: carrierName2
          },
          `${carrierName2}`
        );
      });
      return /* @__PURE__ */ React.createElement(
        Tooltip,
        {
          content: /* @__PURE__ */ React.createElement(
            "span",
            {
              style: {
                textDecoration: "underline",
                textDecorationStyle: "dotted"
              }
            },
            "Multiple ",
            props.trailingChip
          ),
          tooltipContent,
          direction: TooltipDirection.Right,
          location: TooltipLocation.Hidden
        }
      );
    }
  } else {
    return /* @__PURE__ */ React.createElement("span", null, state.carrier.name, " ", props.trailingChip);
  }
}
function possibleAccountExecName(props, state) {
  const id = state.carrier.id;
  if (props.displayAccountExec && id) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, "Account Exec:\xA0"), /* @__PURE__ */ React.createElement("span", null, accountExecName(state)));
  }
}
function accountExecName(state) {
  var exec = state.carrier.account_exec;
  if (!exec) {
    exec = "Not set for " + Account.carrierTermLower();
  }
  return /* @__PURE__ */ React.createElement("span", null, exec);
}
var CarrierName = React.createClass({
  getInitialState: function() {
    return {
      carrier: { name: "Loading " + Account.carrierTerm() + " Name..." }
    };
  },
  componentWillMount: function() {
    this.updateCarrier(this.props);
  },
  componentWillReceiveProps: function(newProps) {
    if (newProps.carrierID !== this.props.carrierID) {
      this.updateCarrier(newProps);
    }
  },
  updateCarrier: function(props) {
    var component = this;
    component.setState({
      carrier: { name: "Loading " + Account.carrierTerm() + " Name..." }
    });
    CarrierService.carrierWithId(props.carrierID).then((carrier) => {
      if (component.isMounted()) {
        component.setState({ carrier });
      }
    }).catch(console.error);
  },
  render: function() {
    if (this.props.v3ReskinEnabled) {
      return renderV3Reskin(this.props, this.state);
    }
    if (this.props.multiple) {
      return /* @__PURE__ */ React.createElement("span", null, "Multiple ", Account.carrierTerm(), "s");
    }
    return /* @__PURE__ */ React.createElement("span", { "data-component": "CarrierName" }, /* @__PURE__ */ React.createElement("span", null, this.props.carrierNamePrefix, carrierName(this.props, this.state), this.props.carrierNameSuffix), possibleAccountExecName(this.props, this.state));
  }
});
export default CarrierName;
